import { jsx } from 'react/jsx-runtime';
import { ToastContainer } from 'react-toastify';

function Toaster() {
    return (jsx(ToastContainer, { position: "top-right", autoClose: 4000, hideProgressBar: false, newestOnTop: true, closeOnClick: true, pauseOnFocusLoss: true, draggable: true, pauseOnHover: true, theme: "light" }));
}

export { Toaster };
//# sourceMappingURL=sonner.js.map
